import { Form } from 'react-bootstrap';
import { connect } from 'formik';
import objectPath from 'object-path';

function EmailField({
  formik = undefined,
  name,
  title,
  required,
  type = 'email',
  plaintext = undefined,
  placeholder = '',
  readOnly = false,
  autoComplete = 'on',
  showValid = false,
  'data-cy': dataCy,
  ...props
}) {
  const errors = objectPath.get(formik.errors, name);
  const touched = objectPath.get(formik.touched, name);
  const value = objectPath.get(formik.values, name);

  return (
    <>
      {type !== 'hidden' && (
        <Form.Label htmlFor={name}>
          {title}
          {required ? '*' : null}
        </Form.Label>
      )}
      <Form.Control
        name={name}
        id={name}
        placeholder={placeholder}
        onChange={formik.handleChange}
        onBlur={(e) => {
          formik.handleBlur(e);
          formik.setFieldValue(name, e.target.value.toLowerCase(), true);
        }}
        value={value}
        isValid={!errors && touched && showValid}
        isInvalid={errors && touched}
        plaintext={!!plaintext}
        readOnly={!!readOnly}
        type={type || 'email'}
        autoComplete={autoComplete}
        data-cy={dataCy}
        {...props}
      />
      {errors && touched ? (
        <div
          className="invalid-feedback"
          {...(dataCy ? { 'data-cy': `${dataCy}-invalid-feedback` } : {})}
        >
          {errors}
        </div>
      ) : null}
    </>
  );
}

export default connect(EmailField);
